
/** Look at current situation and figure out if Bot should use goodTimes,
 badTimes, or default personality */

import {
  getTeamHpRating,
  //getTeamStatusRating
} from '../analysis/team-analysis-utilities'

export function getBotPersonalityForSituation(casterModel, teamCombatants=[]) {
  const teamHpRating = getTeamHpRating(teamCombatants);
  //const teamStatusRating = getTeamStatusRating(teamCombatants);
  //TODO: Currently not using `teamStatusRating` because I'm not sure how it would be balanced

  const defaultPersonality = casterModel.computerAiPersonality.default;
  //Default the goodTimes and badTimes to the same as `defaultPersonality` if they are not explicitly defined
  const goodTimesPersonality = getValidPersonalityObject(casterModel.computerAiPersonality.goodTimes, defaultPersonality);
  const badTimesPersonality = getValidPersonalityObject(casterModel.computerAiPersonality.badTimes, defaultPersonality);

  const value = teamHpRating;
  if (value >= casterModel.goodTimes[0] && value <= casterModel.goodTimes[1]) {
    //times are good!
    return goodTimesPersonality
  }

  if (value >= casterModel.badTimes[0] && value <= casterModel.badTimes[1]) {
    //times are bad!
    return badTimesPersonality
  }

  //Fall back to default personality
  return defaultPersonality;

}

//Check if the input exists AND has keys. Otherwise, fallback to the default
function getValidPersonalityObject(input={}, fallback={}) {
  return (input && Object.keys(input).length) ? input : fallback;
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-bot-personality-for-situation.js